import { Spinner } from '@sbab-ui/components'
import { useEffect, useReducer, useState } from 'react'
import { fetchFixedPrivateRates, fetchInvestmentAccountRates } from '../api/httpHandlers'
import { fixedAppReducer } from '../state/fixedAppState'
import FixedCalculator from '../components/FixedCalculator'
import FixedResult from '../components/FixedResult'
import TopSection from '../components/TopSection'
import { CORPORATE_FIXED_CONFIG, PRIVATE_FIXED_CONFIG } from './config'

interface Props {
  variant: 'corporateFixed' | 'privateFixed'
}

export default function FixedApp({ variant }: Readonly<Props>) {
  const config = variant === 'corporateFixed' ? CORPORATE_FIXED_CONFIG : PRIVATE_FIXED_CONFIG
  const { defaultState } = config
  const { placementAmount } = defaultState
  const [isLoading, setIsLoading] = useState(true)
  const [state, dispatch] = useReducer(fixedAppReducer, defaultState)

  useEffect(() => {
    async function getInterestRates() {
      const { successful, data } =
        variant === 'corporateFixed'
          ? await fetchInvestmentAccountRates(placementAmount)
          : await fetchFixedPrivateRates(placementAmount)
      if (successful) {
        dispatch({ type: 'appDataFetched', interestRateObjs: data, placementAmount })
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch({ type: 'error' })
      }
    }
    getInterestRates()
  }, [])

  return (
    <section>
      {isLoading ? (
        <div className="flex h-96 items-center justify-center">
          <Spinner size="large" />
        </div>
      ) : null}
      {!isLoading && !state.hasAppError ? (
        <>
          <TopSection topTextConfig={config.topText} />
          <FixedCalculator appState={state} appDispatch={dispatch} variant={config.name} />
          <FixedResult appState={state} buttons={config.buttons} variant={config.name} />
        </>
      ) : null}
    </section>
  )
}
